<template>
    <div>
        <div class="s_1280 embr">
            <!-- top panel -->
            <nav class="navbar wrapper navbar-expand-md fixed-top">
                <div class="col-5 menu-right">
                    <router-link to="/home">
                        <img class="logo-img" id="logo-btn" src="images/logo.png" />
                    </router-link>
                </div>
                <div class="col-7">
                    <div class="navigation">
                        <a class="apply-btn" href="/#/newvisa">Apply Now</a>
                        <TopMenu></TopMenu>
                    </div>
                </div>
            </nav>

            <div class="main registration reg">
                <div class="container-fluid wrapper">

                    <div class="row reg-box">

                        <div class="col-5">
                            <h1>Complete</h1>
                            <p>Your evisa application has been submitted. <br />You can later check your application's status, which is available on our home page.</p>
                        </div>

                        <div class="col-7">
                            <div class="reg-form top98">
                                <div class="reg-completed">
                                    <div class="form-group row">
                                        <h2>Thank you!</h2>
                                        <h3>Your application has been submitted!</h3>
                                        <p></p>
                                        <p class="continue-msg">Your application number</p>
                                        <h3>{{this.appNum}}</h3>
                                    </div>
                                    <div class="reg-div"></div>
                                    <div class="form-group row">
                                        <div class="col-sm-12 submit-row">

                                        </div>
                                    </div>

                                </div>


                            </div>  <!-- reg-form top98 -->
                        </div>   <!-- col-7-->

                    </div> <!-- row reg-box -->

                </div> <!-- container-fluid wrapper -->
            </div> <!-- main registration reg -->

        </div>
        <div class="bg white s_768">
            <div class="d-flex flex-column flex-md-row align-items-center mb-3 bg-white">
                <div class="container-fluid wrapper index">
                    <div class="nav-top row">
                        <div class="col-4">
                            <router-link to="/home">
                                <img class="logo-img" id="logo-btn" src="images/logo.png" />
                            </router-link>
                        </div>
                        <div class="col-8">
                            <div class="navigation">
                                <TopMenu :ShowContinueSubmission=true></TopMenu>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
   
            <div class="row">
                <div class="col-12 app top64">
                    <h1 class="bt-32 top64">Complete</h1>
                    <p>Your evisa application has been submitted. <br />You can later check your application's status, which is available on our home page.</p>
                    <div class="row reg-box">
                     
                            <div class="reg-form">
                                <div class="reg-completed">
                                    <div class="form-group row top64">
                                        <h2>Thank you!</h2>
                                        <h3>Your application has been submitted!</h3>
                                        <p></p>
                                        <p class="continue-msg">Your application number</p>
                                        <h3>{{this.appNum}}</h3>
                                    </div>
                                </div>
                            </div>  <!-- reg-form top98 -->
                   

                    </div> <!-- row reg-box -->
                </div>
              
            </div>
           
            <div class="row">
                <div class="col-12">
                    <div class="placeholder">
                        <img src="/images/auth-bird-768.jpg" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TopMenu from "./Menu";
    export default {
        components: {
            TopMenu
        },
        name: 'Final',

        data: () => ({

        }),
        mounted() {

        },
        computed: {
            appNum: function () {
                //return this.$store.state.appNum;
                return this.$cookie.get('eVisaAppID')
            }
        },
        methods: {
        }
    }
</script>

<style scoped>
</style>